<template>
  <div class="matches-layout" style="height: 100%;" :key="this.change">
    <m-scrollbar id="live-event-scrollbar">
      <event />
    </m-scrollbar>
  </div>
</template>

<script>
import MScrollbar from '@/components/MScrollbar'
import Event from '@/components/live/eventview/Event'

export default {
  components: { MScrollbar, Event },
  data () {
    return {
      updateInterval: null,
      changeInterval: null,
      change: 0
    }
  },
  watch: {
    '$route' (to, from) {
      this.getMatch()
    },
    '$i18n.locale' (to, from) {
      this.$store.dispatch('live/GET_EVENT', this.$route.params.event)
    }
  },
  mounted () {
    this.getMatch()
    this.updateChange()
  },
  beforeDestroy () {
    clearInterval(this.updateInterval)
    clearInterval(this.changeInterval)
    this.$store.commit('live/CLEAR_EVENTVIEW')
  },
  methods: {
    getMatch () {
      let scrollbar = document.querySelector('#live-event-scrollbar')
      scrollbar.scrollTop = 0
      const dispatchGetting = () => {
        this.$store.dispatch('live/GET_EVENT', this.$route.params.event)
      }
      dispatchGetting()
      this.updateInterval = setInterval(function () {
        dispatchGetting()
      }, 1000)
    },
    updateChange () {
      const dispatch = () => {
        if (this.change < 2) {
          this.change += 1
        } else {
          clearInterval(this.changeInterval)
        }
      }
      this.changeInterval = setInterval(function () {
        dispatch()
      }, 100)
    }
  }
}
</script>

<style scoped>
.matches-layout { height: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/live/eventview/View.vue